"use client";

import { useLingui } from "@lingui/react/macro";
import { Button } from "@offstreetparking/design-system/forms";
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
import { useCompany } from "../../../../providers/company";
import { useParker } from "../../../../providers/parker";
import { routes } from "../../../../routes";
import { useKiosk } from "../../../providers/KioskProvider";

export const ViewMyPermitsButton = () => {
	const { t } = useLingui();
	const { isKiosk } = useKiosk();
	const { company: portalCompany } = useCompany();
	const { globalParkerFlag } = useFeatureFlags();
	const optionalParkerAccounts = !!globalParkerFlag || !!portalCompany?.isOptionalParkerAccountsEnabled;
	const { isLoggedIn, enabled } = useParker();

	if (!optionalParkerAccounts || !enabled || !isLoggedIn || isKiosk) {
		return null;
	}

	return (
		<div className="p-4 sm:p-8 print:hidden">
			<Button intent="primary" href={routes.permits()} className="w-full justify-center">
				{t`View my permits`}
			</Button>
		</div>
	);
};
